import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommentsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Comments",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.77 21.12h2.69v5.38c0 .89.72 1.61 1.62 1.61.45 0 .85-.18 1.14-.47l6.53-6.53h8.49c2.08 0 3.76-1.69 3.77-3.77V7.65c0-2.08-1.69-3.76-3.77-3.77H5.77C3.69 3.88 2.01 5.57 2 7.65v9.69c0 2.08 1.69 3.76 3.77 3.77Zm8.08-8.62c0-1.19.96-2.15 2.15-2.15s2.15.96 2.15 2.15-.96 2.15-2.15 2.15-2.15-.96-2.15-2.15m-7.54 0c0-1.19.96-2.15 2.15-2.15s2.15.96 2.15 2.15-.96 2.15-2.15 2.15-2.15-.96-2.15-2.15m15.08 0c0-1.19.96-2.15 2.15-2.15s2.15.96 2.15 2.15-.96 2.15-2.15 2.15-2.15-.96-2.15-2.15"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M1 22.43c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V5.29a3.45 3.45 0 0 1 3.44-3.43h12.57c1.89 0 3.43 1.54 3.43 3.43v9.14c0 1.89-1.54 3.43-3.43 3.43H6.04L1.8 22.1c-.22.22-.51.33-.81.33ZM3.29 4.14c-.63 0-1.14.51-1.14 1.14v13.24l2.62-2.62c.21-.21.5-.33.81-.33h10.29c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H3.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M30.71 29.29c-.3 0-.59-.12-.81-.33l-4.24-4.24h-9.81c-1.89 0-3.43-1.54-3.43-3.43a1.14 1.14 0 1 1 2.28 0c0 .63.51 1.14 1.14 1.14h10.29c.3 0 .59.12.81.33l2.62 2.62V12.14c0-.63-.51-1.14-1.14-1.14h-5.71a1.14 1.14 0 1 1 0-2.28h5.71c1.89 0 3.43 1.54 3.43 3.43v16a1.154 1.154 0 0 1-1.15 1.15Z"
      })]
    })
  }));
};